import { schema } from "normalizr";

const sitelinkTemplate = new schema.Entity("sitelinkTemplates", {});

export default {
    SITELINK_TEMPLATE_LIST: { data: [sitelinkTemplate] },
    SITELINK_TEMPLATE: sitelinkTemplate
};
